import React from 'react';

// Pure SVG bamboo leaf — no logo cropping, no letter fragments
export const SectionDivider = () => {
  return (
    <div
      data-testid="section-divider"
      className="bg-neutral-950 flex justify-center items-center"
      aria-hidden="true"
    >
      <div className="w-full max-w-5xl px-6 sm:px-10 lg:px-16 py-10 md:py-14 flex justify-center items-center">
        <span className="flex-1 h-px bg-gradient-to-r from-transparent via-white/10 to-white/10"></span>
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="mx-6 opacity-80"
          aria-hidden="true"
        >
          {/* Stem */}
          <path
            d="M20 4 C 20 12, 21 22, 23 36"
            stroke="#9bab9a"
            strokeWidth="1"
            strokeLinecap="round"
            fill="none"
            opacity="0.7"
          />
          {/* Left leaf */}
          <path
            d="M20 14 C 12 13, 7 18, 6 26 C 14 25, 19 22, 20 14 Z"
            fill="#9bab9a"
            opacity="0.85"
          />
          {/* Right leaf */}
          <path
            d="M21 10 C 28 9, 32 13, 33 20 C 26 19, 22 16, 21 10 Z"
            fill="#9bab9a"
            opacity="0.7"
          />
          {/* Lilac bud accent */}
          <circle cx="20" cy="6" r="2.2" fill="#c8b6d9" opacity="0.9" />
        </svg>
        <span className="flex-1 h-px bg-gradient-to-l from-transparent via-white/10 to-white/10"></span>
      </div>
    </div>
  );
};
